import React from 'react'
import './index.css';
import Property3 from '../../../component/Explore/Propertypage'

const Property = () => {
  return (
    <div>
      <Property3 num="+91-2934572" type="Micro Rustic Cabin" desc="Come and enjoy the experience of a micro rustic cabin with your soul. Enjoy the vibe of a vibrant weather and a cosy location." roomdesc = "Help your roommates in their regular life and to have a entertaining days to make him feel less lonely" price = "0" guests="1" bed="1"  bath="1"/>
    </div>
  )
}

export default Property
